"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteWorkItemRelation = exports.postWorkItemRelation = exports.putWorkItemOrganization = exports.delWorkItem = exports.postWorkItem = exports.putWorkItem = exports.getWorkItem = exports.getWorkItems = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var path = root_1.projectManagementAuthorized + '/workItems/';

var getWorkItems = function getWorkItems(authentication, queryParameters) {
  return common_1.get(authentication, path, queryParameters);
};

exports.getWorkItems = getWorkItems;

var getWorkItem = function getWorkItem(authentication, id) {
  return common_1.get(authentication, path + id);
};

exports.getWorkItem = getWorkItem;

var putWorkItem = function putWorkItem(authentication, workItem) {
  return common_1.put(authentication, path + workItem.id, workItem);
};

exports.putWorkItem = putWorkItem;

var postWorkItem = function postWorkItem(authentication, workItem) {
  return common_1.post(authentication, path, workItem);
};

exports.postWorkItem = postWorkItem;

var delWorkItem = function delWorkItem(authentication, id) {
  return common_1.del(authentication, path + id);
};

exports.delWorkItem = delWorkItem;

var putWorkItemOrganization = function putWorkItemOrganization(authentication, id, accessibility) {
  return common_1.putEntityOrganization(authentication, path, id, accessibility);
};

exports.putWorkItemOrganization = putWorkItemOrganization;

var postWorkItemRelation = function postWorkItemRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, path, id, relation);
};

exports.postWorkItemRelation = postWorkItemRelation;

var deleteWorkItemRelation = function deleteWorkItemRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, path, id, relationId);
};

exports.deleteWorkItemRelation = deleteWorkItemRelation;